import {slideUp, slideDown} from "./slide";

export default class Accordion{
    
    constructor(){
        this.accordions = document.querySelectorAll('.accordion__item');
        this.openedAccordion;
        this.sliding = false;
        this.animating = false; 
        if (this.accordions){
            this.init();
        }
    }
    
    init(){
        this.accordions.forEach((accordion) =>{
            let header = accordion.querySelector('.accordion__item-header');
            let content = accordion.querySelector('.accordion__item-content');

            header.addEventListener('click', () => {
                if (!this.animating){
                    this.animating = true;
                    if (this.openedAccordion){
                        this.openedAccordion.element.classList.remove('active');
                        slideUp(this.openedAccordion.content, 500, () => { this.animating = false });
                        if (this.openedAccordion.element == accordion){
                            this.openedAccordion = null;
                            return;
                        }
                        this.openedAccordion = null;
                    }

                    accordion.classList.add('active');
                    slideDown(content, 500, () => { this.animating = false });

                    this.openedAccordion = {
                        'element' : accordion,
                        'header' : header,
                        'content' : content,
                    };
                }
            });
        });
    }
}